module.exports = __webpack_public_path__ + "img/5.07b12b01.jpg";